import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {advertisementStatisticsResourceType} from "./configs/advertisement-statistics-modal-config";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {
  RecordData,
  RecordUpdateRequestParams
} from "../../../types/records-table.types";
import {defaultRecordPropertyData} from "../../../models/default-record-property-data";
import {AdvertisementStatisticsDialogData} from "./types/advertisement-statistics-modal.types";
import {FormFieldUpdate} from "../../../types/file.types";
import {
  AdvertisementStatisticsFieldsComponent
} from "./components/advertisement-statistics-fields/advertisement-statistics-fields.component";
import {
  AdvertisementStatisticsButtonsComponent
} from "./components/advertisement-statistics-buttons/advertisement-statistics-buttons.component";
import {GetRecordPropertyDataByIdParams} from "../base-modal/types/base-modal.types";
import {CurrentUserRoleAndLogin} from "../../../types/auth.types";
import {LoadingService} from "../../../services/loading.service";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-advertisement-statistics-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FormsModule,
    ReactiveFormsModule,
    AdvertisementStatisticsFieldsComponent,
    AdvertisementStatisticsButtonsComponent,
    LoaderComponent
  ],
  templateUrl: './advertisement-statistics-modal.component.html',
  styleUrls: [
    './advertisement-statistics-modal.component.scss',
    '../base-modal/base-modal.component.scss'
  ],
  providers: [ LoadingService ]
})
export class AdvertisementStatisticsModalComponent extends BaseModalComponent {
  public advertisementStatisticsDialogData = inject<AdvertisementStatisticsDialogData>(MAT_DIALOG_DATA);

  public readonly advertisementStatisticsResourceType = advertisementStatisticsResourceType;
  public recordData: RecordData | null = null;
  public loginAndRoles: CurrentUserRoleAndLogin | null = null;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.loadingService.setIsLoadingState(true);
    this.loginAndRoles = this.authService.getRolesAndLogin();
    this.modalStatesService.openModal(advertisementStatisticsResourceType.path);
    await this.fetchAdvertisementInitialStatisticsData();
    this.loadingService.setIsLoadingState(false);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(advertisementStatisticsResourceType.path);
  }

  public async fetchAdvertisementInitialStatisticsData(): Promise<void> {
    const getRecordPropertyDataByIdParams: GetRecordPropertyDataByIdParams = {
      path: advertisementStatisticsResourceType.path,
      resourceId: Number(this.advertisementStatisticsDialogData.advertisementStatisticsId)
    };

    this.recordData = await this.fetchRecordPropertyDataById<RecordData>(getRecordPropertyDataByIdParams)
      .catch(() => defaultRecordPropertyData);
  }

  public async updatedField({ newValue, key }: FormFieldUpdate): Promise<void> {
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: advertisementStatisticsResourceType.path,
      recordId: Number(this.advertisementStatisticsDialogData.advertisementStatisticsId),
      fieldName: key,
      value: newValue
    };

    await this.updatedRecordField<RecordData>(recordUpdateRequestParams)
      .then(updatedRecord => this.recordData = updatedRecord);
  }
}
